<div class="min-h-screen bg-gray-50 dark:bg-gray-950 flex flex-col md:flex-row">
  <!-- Mobile Overlay -->
  @if (sidebarOpen()) {
    <button
      type="button"
      class="fixed inset-0 bg-black/50 z-30 md:hidden"
      aria-label="Cerrar menú"
      (click)="closeSidebar()"
    ></button>
  }

  <!-- Sidebar -->
  <aside
    class="bg-white dark:bg-gray-900 border-r border-gray-200 dark:border-gray-800 flex flex-col fixed left-0 top-0 h-screen z-40 transition-all duration-300 ease-in-out md:sticky md:top-0 md:h-screen md:translate-x-0"
    [class.w-64]="!sidebarCollapsed()"
    [class.md:w-20]="sidebarCollapsed()"
    [class.-translate-x-full]="!sidebarOpen()"
  >
    <!-- Header -->
    <div
      class="p-4 border-b border-gray-200 dark:border-gray-800 flex items-center justify-between overflow-hidden"
    >
      <div
        class="flex items-center justify-center transition-all duration-300"
        [class.opacity-0]="sidebarCollapsed()"
        [class.w-0]="sidebarCollapsed()"
      >
        <img src="assets/SVG/sdi_logo_red.svg" alt="SDi Logo" class="h-8 w-auto dark:hidden" />
        <img
          src="assets/SVG/sdi_logo_white.svg"
          alt="SDi Logo"
          class="h-8 w-auto hidden dark:block"
        />
      </div>

      <!-- Collapse toggle (Desktop) -->
      <button
        type="button"
        (click)="toggleSidebarCollapse()"
        class="hidden md:flex p-2 text-gray-500 hover:text-gray-900 dark:text-gray-400 dark:hover:text-white hover:bg-gray-100 dark:hover:bg-gray-800 rounded-lg transition-colors ml-auto"
        [class.rotate-180]="sidebarCollapsed()"
      >
        <fa-icon [icon]="faBars" class="text-lg"></fa-icon>
      </button>
    </div>

    <!-- Main Menu -->
    <nav class="flex-1 overflow-y-auto py-4 overflow-x-hidden">
      <div class="px-3">
        <div
          class="text-[10px] font-bold text-gray-400 dark:text-gray-500 uppercase tracking-widest mb-2 px-3 transition-all duration-300 whitespace-nowrap"
          [class.opacity-0]="sidebarCollapsed()"
        >
          {{ sidebarCollapsed() ? '' : 'Menú Principal' }}
        </div>
        <ul class="space-y-1">
          <li>
            <a
              routerLink="/dashboard"
              routerLinkActive="nav-link-active"
              [routerLinkActiveOptions]="{ exact: true }"
              class="flex items-center gap-3 px-3 py-2 rounded-lg text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-800 transition-colors group relative"
              (click)="closeSidebar()"
              [title]="sidebarCollapsed() ? 'Dashboard' : ''"
            >
              <fa-icon [icon]="faChartLine" class="text-lg w-6 flex justify-center"></fa-icon>
              <span
                class="text-sm font-medium transition-all duration-300 whitespace-nowrap"
                [class.opacity-0]="sidebarCollapsed()"
                [class.w-0]="sidebarCollapsed()"
                >Dashboard</span
              >
            </a>
          </li>
          @if (!isAdmin) {
            <li>
              <a
                routerLink="/mi-ficha"
                routerLinkActive="nav-link-active"
                (click)="closeSidebar()"
                class="flex items-center gap-3 px-3 py-2 rounded-lg text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-800 transition-colors group relative"
                [title]="sidebarCollapsed() ? 'Mi Ficha' : ''"
              >
                <span class="relative w-6 flex justify-center flex-shrink-0">
                  <fa-icon [icon]="faIdCard" class="text-lg"></fa-icon>
                  @if (contractStatusService.hasPendingSignature()) {
                    <span
                      class="absolute -top-0.5 -right-0.5 w-2 h-2 rounded-full bg-red-500 ring-2 ring-white dark:ring-gray-900"
                      title="Tienes un contrato pendiente de firma"
                    ></span>
                  }
                </span>
                <span
                  class="text-sm font-medium transition-all duration-300 whitespace-nowrap"
                  [class.opacity-0]="sidebarCollapsed()"
                  [class.w-0]="sidebarCollapsed()"
                  >Mi Ficha</span
                >
              </a>
            </li>
          }
          <li>
            <a
              routerLink="/opportunities"
              routerLinkActive="nav-link-active"
              (click)="closeSidebar()"
              class="flex items-center gap-3 px-3 py-2 rounded-lg text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-800 transition-colors group relative"
              [title]="sidebarCollapsed() ? 'Oportunidades' : ''"
            >
              <fa-icon [icon]="faFileContract" class="text-lg w-6 flex justify-center"></fa-icon>
              <span
                class="text-sm font-medium transition-all duration-300 whitespace-nowrap"
                [class.opacity-0]="sidebarCollapsed()"
                [class.w-0]="sidebarCollapsed()"
                >Oportunidades</span
              >
            </a>
          </li>
        </ul>
      </div>

      @if (isAdmin) {
        <div class="px-3 mt-6">
          <div
            class="text-[10px] font-bold text-gray-400 dark:text-gray-500 uppercase tracking-widest mb-2 px-3 transition-all duration-300 whitespace-nowrap"
            [class.opacity-0]="sidebarCollapsed()"
          >
            {{ sidebarCollapsed() ? '' : 'Admin' }}
          </div>
          <ul class="space-y-1">
            <li>
              <a
                routerLink="/admin/partners"
                routerLinkActive="nav-link-active"
                (click)="closeSidebar()"
                class="flex items-center gap-3 px-3 py-2 rounded-lg text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-800 transition-colors group relative"
                [title]="sidebarCollapsed() ? 'Partners' : ''"
              >
                <fa-icon [icon]="faHandshake" class="text-lg w-6 flex justify-center"></fa-icon>
                <span
                  class="text-sm font-medium transition-all duration-300 whitespace-nowrap"
                  [class.opacity-0]="sidebarCollapsed()"
                  [class.w-0]="sidebarCollapsed()"
                  >Partners</span
                >
              </a>
            </li>
            <li>
              <a
                routerLink="/admin/users"
                routerLinkActive="nav-link-active"
                (click)="closeSidebar()"
                class="flex items-center gap-3 px-3 py-2 rounded-lg text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-800 transition-colors group relative"
                [title]="sidebarCollapsed() ? 'Usuarios' : ''"
              >
                <fa-icon [icon]="faUsers" class="text-lg w-6 flex justify-center"></fa-icon>
                <span
                  class="text-sm font-medium transition-all duration-300 whitespace-nowrap"
                  [class.opacity-0]="sidebarCollapsed()"
                  [class.w-0]="sidebarCollapsed()"
                  >Usuarios</span
                >
              </a>
            </li>
            <li>
              <a
                routerLink="/admin/products"
                routerLinkActive="nav-link-active"
                (click)="closeSidebar()"
                class="flex items-center gap-3 px-3 py-2 rounded-lg text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-800 transition-colors group relative"
                [title]="sidebarCollapsed() ? 'Productos' : ''"
              >
                <fa-icon [icon]="faBox" class="text-lg w-6 flex justify-center"></fa-icon>
                <span
                  class="text-sm font-medium transition-all duration-300 whitespace-nowrap"
                  [class.opacity-0]="sidebarCollapsed()"
                  [class.w-0]="sidebarCollapsed()"
                  >Productos</span
                >
              </a>
            </li>
            <li>
              <a
                routerLink="/admin/relationship-types"
                routerLinkActive="nav-link-active"
                (click)="closeSidebar()"
                class="flex items-center gap-3 px-3 py-2 rounded-lg text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-800 transition-colors group relative"
                [title]="sidebarCollapsed() ? 'Modelos de Relación' : ''"
              >
                <fa-icon [icon]="faSitemap" class="text-lg w-6 flex justify-center"></fa-icon>
                <span
                  class="text-sm font-medium transition-all duration-300 whitespace-nowrap"
                  [class.opacity-0]="sidebarCollapsed()"
                  [class.w-0]="sidebarCollapsed()"
                  >Modelos de Relación</span
                >
              </a>
            </li>
          </ul>
        </div>
      }

      @if (!isAdmin) {
        <div class="px-3 mt-6">
          <div
            class="text-[10px] font-bold text-gray-400 dark:text-gray-500 uppercase tracking-widest mb-2 px-3 transition-all duration-300 whitespace-nowrap"
            [class.opacity-0]="sidebarCollapsed()"
          >
            {{ sidebarCollapsed() ? '' : 'Soporte' }}
          </div>
          <ul class="space-y-1">
            <li>
              <a
                routerLink="/contact"
                routerLinkActive="nav-link-active"
                (click)="closeSidebar()"
                class="flex items-center gap-3 px-3 py-2 rounded-lg text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-800 transition-colors group relative"
                [title]="sidebarCollapsed() ? 'Contacto' : ''"
              >
                <fa-icon
                  [icon]="faCircleQuestion"
                  class="text-lg w-6 flex justify-center"
                ></fa-icon>
                <span
                  class="text-sm font-medium transition-all duration-300 whitespace-nowrap"
                  [class.opacity-0]="sidebarCollapsed()"
                  [class.w-0]="sidebarCollapsed()"
                  >Contacto</span
                >
              </a>
            </li>
          </ul>
        </div>
      }
    </nav>

    @if (!sidebarCollapsed()) {
      <div class="px-6 pb-1">
        <span class="text-[10px] font-semibold text-gray-400 dark:text-gray-600 tracking-wide"
          >v{{ appVersion }}</span
        >
      </div>
    }

    <!-- User Profile -->
    <div class="border-t border-gray-200 dark:border-gray-800 p-3 overflow-hidden">
      <a
        (click)="closeSidebar()"
        routerLink="/profile"
        class="flex items-center gap-3 px-2 rounded-lg hover:bg-gray-100 dark:hover:bg-gray-800 transition-colors cursor-pointer group relative"
        [title]="sidebarCollapsed() ? currentUser?.name : ''"
      >
        <div
          class="w-9 h-9 rounded-full flex items-center justify-center flex-shrink-0 shadow-sm"
          style="background: linear-gradient(135deg, #fc415a 0%, #55dcce 100%)"
        >
          <span class="text-white text-sm font-bold">{{
            currentUser?.name?.charAt(0)?.toUpperCase() || '?'
          }}</span>
        </div>
        <div
          class="flex-1 min-w-0 transition-all duration-300"
          [class.opacity-0]="sidebarCollapsed()"
          [class.w-0]="sidebarCollapsed()"
        >
          <div class="text-sm font-bold text-gray-900 dark:text-white truncate">
            {{ currentUser?.name }}
          </div>
          <div
            class="text-[10px] font-bold uppercase tracking-tighter text-gray-400 dark:text-gray-500 truncate"
          >
            {{ currentUser?.roles?.[0] }}
          </div>
        </div>
        <button
          type="button"
          (click)="logout(); $event.preventDefault(); $event.stopPropagation()"
          class="p-2 text-gray-400 hover:text-red-500 dark:hover:text-red-400 transition-colors"
          [class.hidden]="sidebarCollapsed()"
          aria-label="Cerrar sesión"
        >
          <fa-icon [icon]="faRightFromBracket" class="text-base"></fa-icon>
        </button>
      </a>
    </div>
  </aside>

  <!-- Main Content -->
  <main class="flex-1 overflow-auto bg-gray-50 dark:bg-[#0f1419] flex flex-col w-full md:flex-1">
    <!-- Mobile Header with Hamburger Menu -->
    <div
      class="md:hidden bg-white dark:bg-gray-900 border-b border-gray-200 dark:border-gray-800 px-4 py-3 flex items-center justify-between fixed inset-x-0 top-0 z-30"
    >
      <button
        type="button"
        (click)="toggleSidebar()"
        class="p-2 text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-800 rounded-lg transition-colors"
        [attr.aria-label]="sidebarOpen() ? 'Cerrar menú' : 'Abrir menú'"
      >
        <fa-icon [icon]="sidebarOpen() ? faXmark : faBars" class="text-xl"></fa-icon>
      </button>
      <div class="text-sm font-semibold text-gray-900 dark:text-white">Partner Portal</div>
      <div class="w-10"></div>
    </div>

    <!-- Page Content -->
    <div class="flex-1 overflow-auto pt-14 md:pt-0">
      <router-outlet></router-outlet>
    </div>
  </main>
</div>
